import { createTheme } from '@mui/material/styles';
import { BRAND, FONT_STACK } from './brand';

// ============================================================================
//  MUI theme — GIGATT APEX
// ============================================================================
//  Pulls its colours from brand.js so the MUI defaults (buttons, links, focus
//  rings, chips) land on the same navy/green pairing the setup and login
//  screens style explicitly. Previously this was a standalone forest-green
//  palette, which is why hand-styled screens and default-styled ones did not
//  match.
//
//  primary   = deep navy — chrome, headers, nav, default buttons
//  secondary = apex green — calls to action, success states, active steps

export const theme = createTheme({
  palette: {
    primary: {
      main:         BRAND.navy,
      light:        BRAND.navyLight,
      dark:         BRAND.navyDark,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main:         BRAND.green,
      light:        BRAND.greenLight,
      dark:         BRAND.greenDark,
      contrastText: '#FFFFFF',
    },
    success: { main: BRAND.green,   light: BRAND.greenLight, dark: BRAND.greenDark },
    error:   { main: BRAND.danger },
    warning: { main: BRAND.warning },
    info:    { main: BRAND.info },
    background: {
      default: BRAND.canvas,
      paper:   BRAND.surface,
    },
    text: {
      primary:   BRAND.ink,
      secondary: BRAND.inkMuted,
      disabled:  BRAND.inkFaint,
    },
    divider: BRAND.line,
  },

  typography: {
    fontFamily: FONT_STACK,
    h1: { fontWeight: 800, letterSpacing: '-1px' },
    h2: { fontWeight: 800, letterSpacing: '-0.6px' },
    h3: { fontWeight: 700, letterSpacing: '-0.4px' },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600 },
  },

  shape: { borderRadius: 10 },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          boxShadow: '0 4px 16px rgba(15,31,61,.06)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        // Dialogs and menus pick this up; keeps corners consistent with cards.
        rounded: { borderRadius: 14 },
      },
    },
  },
});
